module.exports = __webpack_public_path__ + "static/media/Ion-Solar-Logo.545e224f.svg";